import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_LV: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'Vīriešiem',
  components_header_media_2: 'Sievietēm',
  components_header_media_multi_content_2: 'Joga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trenējies gudrāk, jūties labāk.',
  hero_button_text: 'Sāciet tūlīt',
  components_ressources_subheader_text: 'Rokasgrāmatas un padomi',
  components_ressources_span_text: 'Tas apvieno jogas zemisko fokusu, Pilates kontrolēto precizitāti un spēka treniņu dinamisko izaicinājumu, lai atbalstītu vispusīgu un veselīgu dzīvesveidu.',
  components_ressources_card_1_title: 'Jogas padomi',
  components_ressources_card_1_text: 'Īsa pamācība labākam līdzsvaram, elpošanai un plūsmai.',
  components_ressources_card_2_title: 'Pilates padomi',
  components_ressources_card_2_text: 'Vienkārši padomi, kā stiprināt korsetes muskuļus un uzlabot kontroli.',
  components_notes_and_google_title_1: 'Veidojiet spēku',
  components_notes_and_google_title_2: 'Jogas miers',
  components_notes_and_google_title_3: 'Pilates pamatne',
  media_content_section_multi_1_subheader_text: 'Apmācības video',
  media_content_section_multi_2_subheader_text: 'Jogas video',
  media_content_section_multi_3_subheader_text: 'Pilates video',
  text_media_1: 'Vīrieši',
  text_media_2: 'Sievietes',
  page_media_content_menu_biceps: 'Bicepss',
  page_media_content_menu_triceps: 'Tricepss',
  page_media_content_menu_back: 'Atpakaļ',
  page_media_content_menu_chest: 'Krūtis',
  page_media_content_menu_legs: 'Kājas',
  page_media_content_menu_shoulders: 'Pleci',
  page_media_content_menu_abdominals: 'Vēdera muskuļi',
  components_text1_subheader_text: 'Veselīgs uzturs jūsu aktīvajai dzīvei',
  components_text1_span_text: 'Veselīgas receptes, kas atbalsta jūsu treniņus un uzlabo jūsu labsajūtu.',
  components_footer_text: 'Stiprini savu ķermeni, līdzsvaro prātu un kusties ar jēgu – tava vieta sporta zālei, jogai un pilates.',
};